import { createAsyncThunk } from "@reduxjs/toolkit";
import { client as axios } from "../../Utils/axiosClient";

export const getTrikeBreakdownByTrip = createAsyncThunk(
  "trips/getTrikeBreakdownByTrip",
  async ({ tripId, rentalId }, { rejectWithValue }) => {
    try {
      const url = rentalId
        ? `${process.env.REACT_APP_API_URL}/trike-breakdowns/mobile/sos-breakdown/active?rentalId=${rentalId}`
        : `${process.env.REACT_APP_API_URL}/trike-breakdowns/mobile/sos-breakdown/active?tripId=${tripId}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getHubAgents = createAsyncThunk(
  "trips/getHubAgents",
  async ({ hubId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/hub-station/hub-agents?hubId=${hubId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const assignTrikeBreakdownAgent = createAsyncThunk(
  "trips/assignTrikeBreakdownAgent",
  async ({ id, hubId, agentId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/trike-breakdowns/breakdown-request/${id}/assign`,
        { hubId, agentId }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const rejectTrikeBreakdown = createAsyncThunk(
  "trips/rejectTrikeBreakdown",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/trike-breakdowns/breakdown-request/${id}/reject`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


